import { ChangeDetectionStrategy, Component, Injector, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ChecklistListDataService } from '../../checklist/list/checklist-list-data.service';
import { takeUntil } from 'rxjs/operators';
import { ChecklistsReminderService } from '@fi-app/system-notifications/checklists/checklists-reminder.service';
import { ChecklistModel } from '@fi-app/checklist/checklist.model';
import { ObjectTypes, SideListOptionType } from '@fi-shared/types';
import { FiDateFormatOptions } from '@fi-shared/utils';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { ChecklistService } from '@fi-app/checklist/checklist.service';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { FiInfiniteScrollDataSource } from '@fi-shared/fi-items-list/fi-infinite-scroll-data-source';

@Component({
    selector: 'fi-system-notifications-checklists',
    templateUrl: './checklists.component.html',
    styleUrls: ['./checklists.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-system-notifications-checklists' },
    standalone: false,
})
export class SystemNotificationsChecklistsComponent
    extends FiInfiniteScrollDataSource<ChecklistModel>
    implements OnInit, OnDestroy
{
    defaultSortColumnName: string = 'DueDateTime';
    actions: IItemsListAction2[] = [];
    FiStateNames = FiStateNames;
    SideListOptionType = SideListOptionType;
    itemsListType = FiItemsListType.SystemNotificationsChecklists;
    objectType = ObjectTypes.CheckList;

    constructor(
        private checklistListDataService: ChecklistListDataService,
        private checklistsReminderService: ChecklistsReminderService,
        private checklistService: ChecklistService,
        private fiFormatDateService: FiFormatDateService,
        injector: Injector,
    ) {
        super(injector, {});
    }

    ngOnInit() {
        this.setChecklistActions();

        this.checklistsReminderService.checkListReminders$
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe((currentChecklists: ChecklistModel[]) => {
                // now we have new check list reminders, reload system notifications list
                this.reloadData();
            });
    }

    private setChecklistActions() {
        const allowedActions = this.checklistService.getUserAllowedActions();
        Object.keys(allowedActions).forEach((key: string) => {
            this.actions.push(allowedActions[key]);
        });
    }

    getChangedOnCellValue(checklist: ChecklistModel): string {
        return this.fiFormatDateService.formatDate(new Date(checklist.ChangedOn), FiDateFormatOptions);
    }

    getListData() {
        return Promise.resolve(this.checklistsReminderService.checkListReminders);
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
